import { Card, FlexColumn, BottomModal } from "../Common/styles.common";

const setNewOutletIdInLocalStorage = (sellerDetail, onClose) => {
  window.localStorage.setItem("outlet_id", sellerDetail.outlet_id);
  window.localStorage.setItem("outlet_name", sellerDetail.outlet_name);
  onClose();
  window.location.reload(false);
};

export default function OutletSwitchSheet({ visible, onClose, allSellerDetails }) {
  if (!visible) return null;

  return (
    <BottomModal visible={visible} onClose={onClose} showCloseIcon={true}>
      <div className="fs-18 fw-700 mt-4 mb-2 ml-4">Select an Outlet</div>
      <div>
        {allSellerDetails ? (
          allSellerDetails.map((item, index) => {
            let borderCss = "";
            if (index === 0) {
              borderCss = "1px solid #e23844";
            }
            return (
              <Card
                key={item.outlet_id}
                className="mt-2 mb-2 mx-4 my-4"
                border={borderCss}
                onClick={() => setNewOutletIdInLocalStorage(item, onClose)}
              >
                <div className="d-flex align-items-center ml-4">
                  <FlexColumn className="ml-2">
                    <span className="fs-15 fw-600 mb-1 sushi-gray-dark">{item.outlet_name}</span>
                    <span className="fs-13 fw-400 medium-dark-gray">{item.city}</span>
                  </FlexColumn>
                </div>
              </Card>
            );
          })
        ) : (
          <></>
        )}
      </div>
    </BottomModal>
  );
}
